<template>
<v-card
     class="mt-2 ql-editor"
     min-height = "650px"
     style="max-height:inherit"
>
     <v-card-text>
          <p class="confarea">{{ dsp_direction }}</p>
     </v-card-text>
     <v-card-title class="pt-0">
          <h1 class="preview_title" v-html="dsp_title">
          </h1>
     </v-card-title>
     <v-card-subtitle class="preview_title preview_subtitle pt-2" v-html="dsp_subtitle">
     </v-card-subtitle>
     <v-card-text
          style="text-align:right"
     >
          <p class="confarea">
          {{ release_date }}<br >
          <span v-html="dsp_signature"></span>
          </p>
     </v-card-text>
     <v-card-text>
          <div v-html="dsp_summary" class="preview_doc preview_summary"></div>
     </v-card-text>
     <v-card-text>
          <div class="preview_doc" v-html="dsp_doc"></div>
     </v-card-text>
</v-card>
</template>
<script>
module.exports =  {
    props     : ["selected_word"],
     computed : {
          title : function() {
             return this.$store.getters['doc_info/get_title'];
           },
          sub_title : function() {
             return this.$store.getters['doc_info/get_subtitle'];
           },
          summary : function() {
             return this.$store.getters['doc_info/get_summary'];
           },
          release_date : function() {
               let reldate = "○○○○年○○月○○日"
                const moment = require("moment");
               if(this.$store.getters['doc_info/get_release_date'] != "")
                  reldate = moment(this.$store.getters['doc_info/get_release_date']).format('YYYY年MM月DD日');
               return reldate;
           },
          e_doc : function() {
             return this.$store.getters['doc_info/get_doc'];
           },
          direction : function() {
             return this.$store.getters['doc_info/get_direction'];
           },
          signature : function() {
             return this.$store.getters['doc_info/get_signature'];
           },

     },
     watch : {
          title: function(){
               this.init();
          },
          sub_title: function(){
               this.init();
          },
          summary: function(){
               this.init();
          },
          e_doc : function(){
               this.init();
          },
          selected_word: function(){
               if(this.selected_word == "")
               {
                    this.init();
                    return
               }
               this.dsp_title = this.highlight(this.title,this.selected_word);
               this.dsp_subtitle = this.highlight(this.sub_title,this.selected_word);
               this.dsp_summary = this.highlight(this.summary,this.selected_word);
               this.dsp_doc = this.highlight(this.e_doc,this.selected_word);
          },
          direction : function(){
               this.init();
          },
          signature : function(){
               this.init();
          },
     },
    data () {
      return {
          dsp_direction : "宛名(例：報道関係者各位)",
          dsp_signature : "署名(例：〇〇株式会社)",
            dsp_title : "プレスリリースタイトル",
            dsp_subtitle : "プレスリリースサブタイトル",
            dsp_summary : "概要説明",
            dsp_doc : "",
      }
    },
     methods : {
          highlight : function(str, word ){
            var SearchString = '('+word+')';
            var RegularExp = new RegExp( SearchString, "g" );
            var ReplaceString = '<span style="background-color: yellow;">$1</span>';
            var ResString = str.replace( RegularExp , ReplaceString );
            return ResString;
          },
          init : function(){
               if(this.title != "" && this.title != null)
                    this.dsp_title = this.title;
               else
                    this.dsp_title = "プレスリリースタイトル"
               if(this.sub_title != "" && this.sub_title != null)
                    this.dsp_subtitle = this.sub_title;
               else
                    this.dsp_subtitle = "プレスリリースサブタイトル";

               if(this.summary != "" && this.summary != null)
                    this.dsp_summary = this.summary.replaceAll("\n","<br />");
               else
                      this.dsp_summary = "概要説明";

               if(this.e_doc != "" && this.e_doc != null && this.e_doc!='<p>\n</p>')
               {
                    this.dsp_doc = this.e_doc.replaceAll("<p>\n</p>","<br>");
               }
               else
               {
                    this.dsp_doc = "リリース本文(最大8000文字)";
               }

               if(this.direction!="" && this.direction!=null)
               {
                    this.dsp_direction = this.direction;
               }
               else
               {
                    this.dsp_direction = "宛名(例：報道関係者各位)";
               }
               if(this.signature!="" && this.signature != null)
               {
                    this.dsp_signature = this.signature.replaceAll("\n","<br />");
               }
               else
               {
                    this.dsp_signature="署名(例：〇〇株式会社)";
               }

          },
     },
     created : function(){
          this.init();     
     },
     mounted : function(){

     },
  }
</script>
